import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/SectionTopics';
import SectionApp from './components/SectionApp';
import SectionComments from './components/SectionComments';
import SectionFaq from './components/SectionFaq';
import SectionRanking from './components/SectionRanking';
import SectionMedia from './components/SectionMedia';
import SectionCarousel from './components/SectionCarousel';
import SectionFeatures from './components/SectionFeatures';
import SectionContact from './components/SectionContact';
import SectionAbout from './components/SectionAbout';
import SectionUpdates from './components/SectionUpdates';
import SectionCards from './components/SectionCards';
import SectionIndex from './components/SectionIndex';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <SectionApp />
        <SectionComments />
        <SectionFaq />
        <SectionRanking />
        <SectionMedia />
        <SectionCarousel />
        <SectionFeatures />
        <SectionContact />
        <SectionAbout />
        <SectionUpdates />
        <SectionCards />
        <SectionIndex />
      </main>
      <Footer />
    </>
  );
}